import {
  INSPECT_PER_URL_WEBHOOK_EVENTS,
  INSPECT_WEBHOOK_COMPLETED,
} from './inspect-webhook-events';

export interface InspectScheduleEventGuide {
  label: string;
  help: string[];
}

export const INSPECT_SCHEDULE_EVENT_GUIDES: Record<
  string,
  InspectScheduleEventGuide
> = {
  [INSPECT_WEBHOOK_COMPLETED]: {
    label: 'پایان کل وضعیت ایندکس',
    help: [
      'وقتی چک وضعیت ایندکس برای همهٔ آدرس‌های این زمان‌بندی تمام شد، یک‌جا خبر می‌دهد.',
      'مثال: هر شب ۲۰ آدرس چک می‌شود؛ می‌خواهید آخر شب ببینید «تمام شد — ۱۸ تا اوکی، ۲ تا خطا».',
    ],
  },
  [INSPECT_PER_URL_WEBHOOK_EVENTS[0]]: {
    label: 'وضعیت فعلی هر آدرس',
    help: [
      'بعد از چک هر آدرس، اگر وضعیتش با انتخاب شما بخورد همان لحظه خبر می‌دهد — حتی اگر هفتهٔ قبل هم همین وضعیت بود.',
      'مثال: هر هفته همان ۵ صفحه را می‌بینید و می‌خواهید هر بار که هنوز «ایندکس‌نشده»اند پیام بگیرید.',
      'فرق با «تغییر وضعیت»: این یکی هر بار تکرار می‌شود؛ آن یکی فقط وقتی چیزی عوض شده.',
    ],
  },
  [INSPECT_PER_URL_WEBHOOK_EVENTS[1]]: {
    label: 'فقط وقتی وضعیت عوض شد',
    help: [
      'فقط وقتی وضعیت آدرس نسبت به دفعهٔ قبل فرق کرده خبر می‌دهد. بار اول (بدون سابقه) خبری نمی‌رود.',
      'مثال: دیروز «ایندکس‌نشده» بود، امروز «ایندکس‌شده» شد — فقط همین یک‌بار پیام می‌گیرید.',
      'فرق با «وضعیت فعلی»: آن یکی هر هفته تکرار می‌شود؛ این یکی فقط لحظهٔ تغییر.',
    ],
  },
};

export function inspectScheduleEventGuide(
  eventId: string,
): InspectScheduleEventGuide | undefined {
  return INSPECT_SCHEDULE_EVENT_GUIDES[eventId];
}
